<template>
    <div>
        <div class="bg-white social-overlay"></div>
        <img class="social-background" :src="background" />
        <div class="container text-center social-content is-fluid">
            <h2
                class="text-2xl uppercase text-center font-thin leading-tight mb-6"
            >
                Thank you for sharing my property
            </h2>
            <div class="text-center inner">
                <div class="flex flex-row flex-wrap justify-center">
                    <div class="facebook-share-wrapper share-wrapper mb-4">
                        <a @click="FBShare"
                            ><i class="fab fa-facebook-f"></i
                        ></a>
                    </div>
                    <div class="twitter-share-wrapper share-wrapper mb-4">
                        <a @click="tweetMessage"
                            ><i class="fab fa-twitter"></i
                        ></a>
                    </div>
                    <div class="linkedin-share-wrapper share-wrapper mb-4">
                        <a @click="linkedInShare"
                            ><i class="fab fa-linkedin"></i
                        ></a>
                    </div>
                    <div class="pinterest-share-wrapper share-wrapper mb-4">
                        <a @click="pinterestShare"
                            ><i class="fab fa-pinterest"></i
                        ></a>
                    </div>
                    <div class="email-share-wrapper share-wrapper mb-4">
                        <a :href="email" target="_blank"
                            ><i class="far fa-envelope"></i
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["sharemessage", "background"],
    methods: {
        pinterestShare() {
            PinUtils.pinOne({
                url: document.location.href,
                description: this.sharemessage
            });
        },
        linkedInShare() {
            var url =
                "https://www.linkedin.com/shareArticle?mini=true&url=" +
                document.location.href;
            window.open(
                url,
                "_blank",
                "location=1,menubar=0,scrollbars=0,width=550,height=700,status=0"
            );
        },
        tweetMessage() {
            window.open(
                "https://twitter.com/intent/tweet?text=" +
                    encodeURIComponent(
                        this.sharemessage + " " + document.location.href
                    ),
                "_blank",
                "location=1,menubar=0,scrollbars=0,width=550,height=300,status=0"
            );
        },
        FBShare() {
            FB.ui(
                {
                    method: "share",
                    href: document.location.href
                },
                function(response) {}
            );
        }
    },
    computed: {
        email() {
            var url =
                "mailto:?subject=" +
                encodeURI(this.sharemessage) +
                "&body=" +
                encodeURIComponent(
                    this.sharemessage + " " + document.location.href
                );
            return url;
        }
    }
};
</script>
